export function isLinkedListNewEntry(entry) {
    return !Object.hasOwn(entry, 'linkedListEntryHash');
}
export function isLinkedListRawEntry(entry) {
    return Object.hasOwn(entry, 'linkedListEntryHash');
}
//# sourceMappingURL=types.js.map